import undoable from "redux-undo";

const removeKey = (key, { [key]: _, ...rest }) => rest;

const comReducer = (state = {}, action) => {
  switch (action.type) {
    // case "OPTIMIZATION_RUN":
    //   return {
    //     ...state,
    //     optimization_run_status: action.payload,
    //   };

    // case "FETCH_OPTIMIZATION": {
    //   return {
    //     ...state,
    //     optimization_data: action.payload.data,
    //     loading: action.payload.loading,
    //   };
    // }

    // case "REMOVE_OPTIMIZATION": {
    //   return state;
    // }

    // case "REMOVE_OPTIMIZATION_LOCAL": {
    //   return {
    //     ...state,
    //     optimization_history: removeKey(action.payload, state.optimization_history),
    //   };
    // }

    // case "FETCH_OPTIMIZATION_HISTORY": {
    //   return {
    //     ...state,
    //     optimization_history: action.payload.history,
    //     loading: action.payload.loading,
    //   };
    // }

    case "SET_NEW_COM_HISTORY": {
      return state;
    }
    case "FETCH_COM_HISTORY": {
      return {
        ...state,
        com_history: action.payload.history,
        com_history_filtred: action.payload.history,
        loading: action.payload.loading,
      };
    }

    case "SET_COM_HISTORY": {
      return {
        ...state,
        all_history: action.payload.history,
        all_history_filtred: action.payload.history,
        loading: action.payload.loading,
      };
    }
    case "SET_COM_HISTORY_FILTRED": {
      return {
        ...state,
        all_history_filtred: action.payload.history,
        loading: action.payload.loading,
      };
    }
    case "REMOVE_COM": {
      return state;
    }

    case "REMOVE_COM_LOCAL": {
      return {
        ...state,
        com_history: removeKey(action.payload, state.com_history),
        com_history_filtred: removeKey(action.payload, state.com_history_filtred),
      };
    }

    default:
      return state;
  }
};

// export default optimizationReducer;

// const undoablComReducer = undoable(comReducer);

export default comReducer;
